import React from 'react'
import {
  DigestiveBenefitsRoot,
  Header,
  DigestiveBenefitsContainer,
} from './DigestiveBenefits.styles'
import { ImageWithText } from 'components/Sections/ImageWithText'
import bowl from '../../../../../public/assets/raw-benefits/golden-retriever-raw-dog-food-bowl.webp'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'
import Trans from 'next-translate/Trans'
import Link from 'next/link'

export const DigestiveBenefits: React.FC = () => {
  const { t } = useTranslation()

  const DigestiveCopy = () => (
    <Stack gap="3" direction="column">
      <Text weight='bold' size='headline'>{t('raw-benefits:digestive-benefits.body.0')}</Text>
      <Text>{t('raw-benefits:digestive-benefits.body.1')}</Text>
      <Text>
        <Trans i18nKey='raw-benefits:digestive-benefits.body.2' components={{Bold: <Text weight="bold" />}} /></Text>
      <Text>
        <Trans
          i18nKey="raw-benefits:digestive-benefits.body.3"
          components={{
            GutHealthLink: <Link href="/blog/best-dog-food-for-gut-health" />,
            Bold: <Text weight="bold" />,
          }}
        />
      </Text>
      <Text>
        <Trans
          i18nKey="raw-benefits:digestive-benefits.body.4"
          components={{
            StudyLink: (
              <Link href="https://www.petfoodindustry.com/nutrition/pet-food-ingredients/article/15638587/raw-fresh-dog-foods-outperformed-extruded-diet-digestibility?utm_source=Omeda&utm_medium=Email&utm_content=NL-Petfood+Industry+News&utm_campaign=NL-Petfood+Industry+News_20231116_0200&oly_enc_id=3025B1696690D4W" />
            ),
          }}
        />
      </Text>
      <Text>{t('raw-benefits:digestive-benefits.body.5')}</Text>
      <Text>{t('raw-benefits:digestive-benefits.body.6')}</Text>
    </Stack>
  )

  return (
    <DigestiveBenefitsRoot>
      <DigestiveBenefitsContainer>
        <Header>{t('raw-benefits:digestive-benefits.title')}</Header>
        <ImageWithText
          copyColumn={<DigestiveCopy />}
          imageSrc={bowl}
          imageAlt="raw-benefits:digestive-benefits.image-alt"
          imageSide="left"
        />
      </DigestiveBenefitsContainer>
    </DigestiveBenefitsRoot>
  )
}

DigestiveBenefits.displayName = 'DigestiveBenefits'
